import React, { useState } from "react";
import styled from "styled-components";

interface ImageProps {
  image: string;
  alt?: string;
  lazy?: boolean;
}

export default function Image({ image, alt = "", lazy = true }: ImageProps) {
  const [loaded, setLoaded] = useState(false);

  if (!image) {
    return <></>;
  }

  return (
    <ImageContainer $loaded={loaded}>
      <img
        src={image}
        alt={alt}
        loading={lazy ? "lazy" : "eager"}
        decoding="async"
        onLoad={() => setLoaded(true)}
      />
    </ImageContainer>
  );
}

const ImageContainer = styled.div<{ $loaded: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    opacity: ${(props) => (props.$loaded ? 1 : 0)};
    transition: opacity 0.18s ease;
  }
`;
